import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const browseProjectRedirectRoute: InvariantJiraRoute = {
	name: 'browse-project-redirect',
	path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
	exact: true,
};
